var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex page-header mbm-3 justify-content-between"},[_c('div',[_vm._v(_vm._s(_vm.headerName))]),_c('div',{staticClass:"d-flex end-0"},[_c('div',[_vm._v(_vm._s(_vm.headerContent))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }